import { JOB_FAMILY_OPTIONS } from '../constants/jobFamily.constants'
import { ONBOARDING_OPTION_ID } from '../constants/uploadResource.constants'
import { FormErrors, FormValues } from '../types/uploadResource.types'

export const isValidUrl = (value: string): boolean => {
  const trimmed = value.trim()
  if (!trimmed) return false
  try {
    const urlToTest = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
    const parsed = new URL(urlToTest)
    return parsed.hostname.includes('.')
  } catch {
    return false
  }
}

export const validateForm = (values: FormValues): FormErrors => {
  const errs: FormErrors = {}
  if (!values.title.trim()) errs.title = 'You need to type a title to submit.'
  if (!values.link.trim() || !isValidUrl(values.link)) errs.link = 'You need to paste a link to submit.'
  if (!values.skills.length) errs.skills = 'Select at least one skill to submit.'
  if (!values.resourceType) errs.resourceType = 'Select one option to submit.'
  if (!values.isGlobal && !values.ou) errs.ou = 'Select one option to submit.'
  if (!values.jobFamily) errs.jobFamily = 'Select one option to submit.'
  return errs
}

export const buildPayload = (
  form: FormValues,
  skillOptions: { key: string; value: string }[],
  ouOptions: { key: string; value: string }[],
) => ({
  title: form.title.trim(),
  link: form.link.trim(),
  description: form.description.trim(),
  skills: form.skills.map(id => skillOptions.find(s => s.value === id)?.key ?? id).join(','),
  resourceType: form.resourceType === ONBOARDING_OPTION_ID ? true : false,
  geography: form.isGlobal ? 'Global' : (ouOptions.find(ou => ou.value === form.ou)?.key ?? form.ou),
  jobFamily: JOB_FAMILY_OPTIONS.find(jf => jf.value === form.jobFamily)?.key ?? form.jobFamily,
})
